import React from 'react';
import { motion } from 'framer-motion';
import { experiences } from '../data/experiences';

const ExperienceSection: React.FC = () => {
  if (experiences.length === 0) {
    return null;
  }

  return (
    <section id="experience" className="py-20 px-6 bg-black text-white">
      <div className="max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="mb-10"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-white to-lavender-200 bg-clip-text text-transparent">
            Experience
          </h2>
          <p className="text-gray-400 text-lg">Internships, research, and systems work</p>
        </motion.div>

        <div className="space-y-6">
          {experiences.map((exp, index) => (
            <motion.div
              key={exp.id}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative pl-6 border-l border-violet-500/30 hover:border-violet-500 transition-colors"
            >
              <div className="absolute -left-1.5 top-1 w-3 h-3 bg-violet-500 rounded-full" />
              <div className="bg-gray-900/40 backdrop-blur-sm border border-gray-800 rounded-lg p-5 hover:border-violet-500/50 transition-all duration-300">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-3">
                  <div>
                    <div className="flex flex-wrap items-center gap-2">
                      <h3 className="text-lg font-semibold text-white">{exp.company}</h3>
                      {exp.title.toLowerCase().includes('research') && (
                        <span className="rounded border border-cyan-400/30 bg-cyan-400/10 px-2 py-0.5 text-xs text-cyan-200">
                          Research
                        </span>
                      )}
                    </div>
                    <p className="text-lavender-200">{exp.title}</p>
                  </div>
                  <div className="text-sm text-gray-400 mt-2 md:mt-0">
                    {exp.startDate} - {exp.endDate}
                  </div>
                </div>
                {exp.location && (
                  <p className="text-sm text-gray-500 mb-4">{exp.location}</p>
                )}
                <ul className="space-y-1.5">
                  {exp.description.map((desc, i) => (
                    <li key={i} className="text-gray-300 flex items-start">
                      <span className="text-violet-500 mr-2">•</span>
                      <span>{desc}</span>
                    </li>
                  ))}
                </ul>
                {exp.technologies && exp.technologies.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-4">
                    {exp.technologies.map((tech) => (
                      <span
                        key={tech}
                        className="px-3 py-1 bg-violet-500/20 text-violet-300 rounded-full text-xs"
                      >
                        {tech}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
